<template>
  <footer class="bg-bkg dark:bg-dark.bkg dark:text-dark.contentText text-contentText bottom-0 w-full py-4 sm:py-6 border-t border-sepBorder dark:border-dark.growth mt-16">
    <section class="container mx-auto px-5 grid grid-cols-1 sm:grid-cols-3 gap-4">
      <!-- Left Column: Logo and Not Affiliated Text -->
      <div class="text-left">
        <logo-component display_moto="true" />
        <div class="text-left mt-5 text-sm" v-html="$t('not_affiliated')"></div>
      </div>

      <!-- Center Column: Legal Links -->
      <div class="text-center">
        <router-link to="/tos" class="hover:text-growth">{{ $t('terms_of_service') }}</router-link> |
        <router-link to="/gdpr" class="hover:text-growth">{{ $t('gdpr') }}</router-link> |
        <router-link to="/privacy" class="hover:text-growth">{{ $t('privacy_policy') }}</router-link>
      </div>

      <!-- Right Column: Copyright, Email, Contact Us, and Social Media -->
      <div class="text-right">
        <p>{{ $t('copyright') }}</p>
        <button @click="show_contactModal = true" class="py-2 hover:text-growth border-0 cursor-pointer text-center">{{ $t('contact_us') }}</button>
        <div class="mt-2">
          <a href="https://www.instagram.com/creatorxone/" target="_blank" rel="noopener noreferrer" :title="$t('social.instagram')" class="mx-2"><font-awesome-icon :icon="['fab', 'instagram']" /></a>
          <a href="https://www.facebook.com/people/CreatorXone/61557008110530/" target="_blank" rel="noopener noreferrer" :title="$t('social.facebook')" class="mx-2"><font-awesome-icon :icon="['fab', 'facebook']" /></a>
          <a href="https://www.youtube.com/@CreatorXone-cx1" target="_blank" rel="noopener noreferrer" :title="$t('social.youtube')" class="ml-2"><font-awesome-icon :icon="['fab', 'youtube']" /></a>
        </div>
      </div>
    </section>

    <!-- Contact Modal Transition -->
    <transition name="zoom-fade">
      <section v-if="show_contactModal" @click="show_contactModal = false" class="backdrop-blur w-full h-full fixed inset-0 bg-gray-700 bg-opacity-30 z-50 flex justify-center items-center px-4 text-black">
        <section @click.stop class="bg-white dark:bg-dark.bkg dark:text-dark.contentText rounded-lg w-full max-h-screen max-w-md sm:max-w-3xl mx-auto my-auto p-8 px-6 sm:p-10 z-50 overflow-auto relative">
          <font-awesome-icon @click="show_contactModal = false" icon="fas fa-xmark" class="transition absolute p-6 top-0 right-0 text-xl cursor-pointer hover:opacity-50" />
          <contact-modal @close="handleClose" />
        </section>
      </section>
    </transition>
  </footer>
</template>

<script setup>
import logoComponent from "@/components/logo.vue";
import contactModal from "@/components/landing/ContactModal.vue";
</script>

<script>
export default {
  name: "FooterPanel",
  components: {
    logoComponent,
    contactModal,
  },
  data() {
    return {
      show_contactModal: false,
    };
  },
  methods: {
    handleClose() {
      this.show_contactModal = false;
    },
    sendMail() {
      const email = "info@creatorxone.com";
      window.location.href = `mailto:${email}`;
    },
  },
};
</script>